module.exports = __webpack_public_path__ + "static/media/online-speech-therapy.7ae0cc19.jpg";